export default __webpack_public_path__ + "static/media/side_add.87ee656c.svg";